import React from 'react';
import styled from 'styled-components';
import Branded from '../components/Branded';

const Section = styled.section`
  background: #fff;
  padding: 80px 0;

  @media (max-width: 768px) {
    padding: 56px 0;
  }
`;

const Card = styled.div`
  display: grid;
  grid-template-columns: ${props => (props.$hasImage ? '1.35fr 1fr' : '1fr')};
  align-items: center;
  gap: 48px;
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px;
  background: #fff;
  border: 1px solid #d8e1ec;
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 44px rgba(19, 120, 229, 0.08);
    border-color: #1378e5;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 28px;
    margin: 0 24px;
    padding: 24px;
  }

  .link-image {
    overflow: hidden;
    border-radius: 6px;
    background: #f2f6fc;

    img {
      width: 100%;
      height: 380px;
      object-fit: cover;
      display: block;
    }

    @media (max-width: 900px) {
      img {
        height: 220px;
      }
    }
  }

  .link-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 24px;

    @media (max-width: 900px) {
      padding-right: 0;
    }
  }

  .link-tag {
    font-size: 12px;
    font-weight: 500;
    color: #f08020;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: 12px;
  }

  .link-title {
    font-size: clamp(1.8rem, 3vw, 2.6rem);
    font-weight: 700;
    color: #111;
    line-height: 1.35;
    margin-bottom: 16px;
  }

  .link-desc {
    font-size: 14.5px;
    font-weight: 300;
    color: #5b6b7c;
    line-height: 1.9;
    margin-bottom: 28px;
    white-space: pre-line;
  }
`;

const VisitButton = styled.a`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.04em;
  color: #fff;
  background: #f08020;
  border: 1.5px solid #f08020;
  border-radius: 999px;
  padding: 15px 30px;
  transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);

  svg {
    width: 13px;
    height: 13px;
    stroke: currentColor;
    fill: none;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    transition: transform 0.3s ease;
  }

  &:hover {
    background: transparent;
    color: #f08020;

    svg {
      transform: translateX(3px);
    }
  }
`;

export default function ExternalLink({
  sectionTag,
  sectionTitle,
  description,
  image,
  ctaLabel,
  url,
}) {
  if (!sectionTitle && !sectionTag && !url) return null;

  return (
    <Section>
      <Card $hasImage={!!image?.asset?.url}>
        {image?.asset?.url && (
          <div className="link-image">
            <img
              src={image.asset.url + '?w=900&auto=format'}
              alt={sectionTitle || ''}
              loading="lazy"
            />
          </div>
        )}
        <div className="link-content">
          {sectionTitle && (
            <Branded as="p" className="link-tag" text={sectionTag} />
          )}
          <Branded
            as="h2"
            className="link-title"
            text={sectionTitle || sectionTag}
          />
          <Branded as="p" className="link-desc" text={description} />
          {url && (
            <VisitButton href={url} target="_blank" rel="noopener noreferrer">
              {ctaLabel || 'Visit Website'}
              <svg viewBox="0 0 24 24">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </VisitButton>
          )}
        </div>
      </Card>
    </Section>
  );
}
